export default __webpack_public_path__ + "static/media/Homescreen-03.b40a546e.jpg";